import { useAccount, useConfig } from "wagmi";
import {   useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import W3ControlMachineABI from "../assets/abis/ControlMachine.json";
import { W3ControlMachine } from "../constants";
import { formatUnits } from "viem";


function  useW3ControlMachine() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const results = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'getData'
          }
        ]
      },[config])

      const nftChanged = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'nftMachine',
            args: [address]
          }
        ]
      },[config,address])

      const personalMachine = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'personalMachine',
            args: [address]
          }
        ]
      },[config,address])

      const getUnOpenMachines = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'getUnOpenMachines',
            args: [address]
          }
        ]
      },[config,address])      
      // console.log('getUnOpenMachines',getUnOpenMachines);USDTReward
      
      
      // console.log('getUSDTRewardClaimed',Number(formatUnits(getUSDTRewardClaimed[0],18)));
      
      const startTime = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'start'
          }
        ]
      },[config])

      setValue({
        nftjoined:Number(results[0][0]),
        totalnft:Number(results[0][1]),
        miningjoined:Number(results[0][2]),
        totalmining:Number(results[0][3]),
        nftChanged: nftChanged[0],
        personalMachine: personalMachine[0],
        unOpenMachines: getUnOpenMachines[0],
        startTime: Number(formatUnits(startTime[0],0))
      })
    } catch (e) {
      console.log(e)
    }
  }, [address, config])

  useEffect(() => {
    if (config ) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, refreshTime]);

  return value
}

export default useW3ControlMachine